import React, {useEffect} from "react";


function Login() {
    useEffect(() => {
        window.location.href = process.env.REACT_APP_authenticator_endPoint;
    }, []);

    return (<></>);

}

export default Login;
